import { Entitlements } from '@griply/types';

// Only the entitlements are read, so a raw user document the backend has not converted qualifies too.
export type UserEntitlements = { entitlements?: Entitlements[] | null };

export const getUserHasPremium = (user: UserEntitlements | null | undefined) =>
  !!user?.entitlements?.includes(Entitlements.Premium);
